import { fork, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import { putAndWaitAPI } from '../api/API.sagas';
import {
    API_POST_THREATMETRIX,
    API_PUT_THREATMETRIX
} from '../api/lendingAPI/LendingAPI.actions';
import { SETUP_THREATMETRIX } from './iwThreatmetrix.actions';

export const threatmetrixSagasWorkers = [fork(setupThreatmetrixWorker)];
export const THREATMETRIX_ORG_ID = '8u0q6ob5';
const ACCOUNT_PAGES_IDENTIFIER = 2;

function* setupThreatmetrixWorker() {
    yield takeLatest(SETUP_THREATMETRIX, function* () {
        yield threatmetrixSetup();

        const response = yield putAndWaitAPI({
            type: API_POST_THREATMETRIX,
            body: JSON.stringify({
                data: { page_id: ACCOUNT_PAGES_IDENTIFIER }
            })
        });
        const sessionID = _.get(response, 'response.data.tm_session_id');

        if (window.threatmetrix) {
            window.threatmetrix.profile(
                'h.online-metrix.net',
                THREATMETRIX_ORG_ID,
                sessionID
            );
            yield putAndWaitAPI({
                type: API_PUT_THREATMETRIX,
                body: JSON.stringify({ data: { is_profiled: true } }),
                sessionID
            });
        }

        yield setupThreatmetrixTagging(sessionID);
    });
}

function threatmetrixSetup() {
    let s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://static.iwoca.com/js/435ebd53-dd09-4a6e-8e26-651f497d92d1.js`;
    document.head.appendChild(s);
}

function setupThreatmetrixTagging(sessionID) {
    let iframe = document.createElement('iframe');
    iframe.title = 'Threatmetrix';
    iframe.src = `https://h.online-metrix.net/fp/tags?org_id=${THREATMETRIX_ORG_ID}&session_id=${sessionID}`;
    iframe.style.position = 'absolute';
    iframe.style.border = '0';
    iframe.style.top = '-5000px';
    iframe.style.height = '1px';
    iframe.style.width = '1px';
    document.body.appendChild(iframe);
}
